<template>
  <div class="notice-right">
    <div class="card">
      <div class="header">
        <span class="title">产品动态</span>
        <el-button
          type="text"
          @click="toNoticeDetail"
        >
          更多
        </el-button>
      </div>
      <ul class="content">
        <li
          v-for="(item, index) in productList"
          :key="index"
          @click="handleJump(item.url)"
        >
          <el-tag
            v-if="item.tag_title"
            type="danger"
            size="mini"
            effect="dark"
            class="notice-tag"
          >
            {{ item.tag_title }}
          </el-tag>
          {{ item.title }}
        </li>
      </ul>
    </div>

    <div class="card">
      <div class="header">
        <span class="title">产品手册</span>
        <a
          target="_blank"
          href="https://shopex.yuque.com/books/share/116d5ca3-e9c0-4b66-9953-36201822d4f9?#"
        >查看</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      text: '',
      topText: '',
      productList: []
    }
  },
  created () {
    this.getAdminList()
  },
  methods: {
    toNoticeDetail () {
      this.$router.push({
        path: '/setting/notice'
      })
    },
    async getAdminList () {
      const data = await this.$api.setting.getAdminList({
        page: 1,
        page_size: 6
      })
      if (data) {
        this.productList = data.product.list
      }
    },
    handleJump (value) {
      window.open(value, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.notice-right {
  max-width: 500px;
  // position: absolute;
  // right: 0;
  // bottom: 100px;
  // z-index: 999;
  .card {
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    padding: 15px;
    margin-bottom: 20px;
    .header {
      display: flex;
      justify-content: space-between;
      align-content: center;
      line-height: 36px;
      .title {
        font-size: 15px;
        line-height: 36px;
        font-weight: bold;
      }
    }
    .content {
      li {
        line-height: 35px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
        .notice-tag {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>
